export default __webpack_public_path__ + "media/images/react_icons/control-chevron-left-dac362615019ffd1a6d88b417cf8de49.svg";